
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import OCROrderApi from "@/api/ocr-order-api";
import eventBus from '@/utils/event-bus';
import UploadApi from "~/api/upload-api"
import Config from "./config"
import { imageFileToWebp } from "@/utils/image";
import CustomUploadApi from "@/api/custom-upload";
// 引入 van-swipe 和 van-swipe-item 组件
import { Dialog } from 'vant';

const C_UPLOAD_FILE_TYPE = "hk_receipt_order_goods"

type MainType = OCROrderApi.IOcrOrderViewItem
type WebFileInfo = UploadApi.IFileDetailView & { url: string };
@Component({ name: "order-editor", })
export default class OrderEditor extends Vue {
    item: MainType = {} as any
    loading = 0;
    id = 0
    files = [] as Array<WebFileInfo>;
    vShow = false

    created() { }
    async mounted() {
        this.id = Number(this.$route.query.id) ?? 0;
        eventBus.emit("upate-nav-title", '创建理货单');
        if (!this.id) {
            UploadApi.getSession().then(e => {
                this.item.FileSessionId = e.SessionId!
            })
            return;
        }
        UploadApi.getFiles({ RelationId: this.id, RelationType: C_UPLOAD_FILE_TYPE }).then(e => this.files = e.map(n => ({ ...n, url: CustomUploadApi.getFileUrl(n.Id!) })))
        this.item = await OCROrderApi.getOrderBaseInfo(this.id, this);
        eventBus.emit("upate-nav-title", `理货单:${this.item.OrderNo}`);
    }
    async onSave() {
        const id = await OCROrderApi.saveOrder(this.item, this);
        this.$router.replace({ name: "ocr-order-detail", query: { id } as any })
    }

    async showUpload(type: number) {
        if (this.coverPhoto) {
            if (type == 1) {
                await Dialog.confirm({ message: "是否删除当前照片？" })
                await UploadApi.del({ Id: this.coverPhoto!.Id })
                this.files = this.files.filter(e => e.Id != this.coverPhoto!.Id)
                return;
            }

            await Dialog.confirm({ message: "是否删除当前照片，重新拍摄？" })
            await UploadApi.del({ Id: this.coverPhoto!.Id })
            this.files = this.files.filter(e => e.Id != this.coverPhoto!.Id)
        }
        (this.$refs["photo"] as HTMLInputElement).click()
    }

    get coverPhoto() {
        if (!this.files.length) return null
        var m = this.files[this.files.length - 1];
        return m;
    }

    get allFileUrl() { return this.files.map(e => e.url); }

    async getUploadPtr() {
        const ptr: CustomUploadApi.ICustomUploadParams = { type: C_UPLOAD_FILE_TYPE } as any
        if (this.id) {
            ptr.relationId = this.id
            return ptr;
        }
        if (!this.item.FileSessionId) {
            var sid = await UploadApi.getSession();
            this.item.FileSessionId = sid.SessionId!
        }
        ptr.sessionId = this.item.FileSessionId
        return ptr;
    }

    async photoOnChange(e: Event) {
        var cnt = e.target as HTMLInputElement;
        if (!cnt) return;
        var file = (cnt.files || [])[0];
        //        console.error(img)
        if (!file) return
        // this.imgOCR("e86256bf-25f8-406a-8d96-97c9829a894f");
        // const dlg = this.$loading({ text: "正在压缩图像" })
        var uploadTask = this.getUploadPtr();

        file = await imageFileToWebp(file, 1024);

        // this.$loading({ text: "正在上传图像" })

        var m = { Id: undefined, url: URL.createObjectURL(file), FileName: file.name } as any as WebFileInfo
        this.files.push(m);

        try {
            const rlt = await CustomUploadApi.uploadFile(await uploadTask, file);
            m.Id = rlt.Id!;
        } catch {
            this.files = this.files.filter(e => e == m);
        }
    }


}
